import { create } from "zustand";
import type { WakeLockStore } from "./types";

export const useWakeLockStore = create<WakeLockStore>((set) => ({
  active: false,
  setActive: (active, type) => set({ active, type }),
}));
